import { render } from "./point-edit.vue?vue&type=template&id=2b52a5b1&scoped=true"
import script from "./point-edit.vue?vue&type=script&lang=js"
export * from "./point-edit.vue?vue&type=script&lang=js"

import "./point-edit.vue?vue&type=style&index=0&id=2b52a5b1&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b52a5b1"]])

export default __exports__